import { TextField } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';
import SystemUtil from '@/util/SystemUtil';

class TextFieldSecretaria extends ReactComponent {
    /**
     * @type {undefined | string}
     */
    valor;

    /**
     * @type {undefined | boolean}
     */
    modificadoExternamente = false;

    /**
     * @type {undefined | number}
     */
    tempoTimeout = this.observableProps.tempoTimeout ? this.observableProps.tempoTimeout : 1000;

    /**
     * @type {undefined | NodeJS.Timeout}
     */
    timerSalvar = undefined;

    /**
     * @type {undefined | boolean}
     */
    desativarTimeout = this.observableProps.desativarTimeout ? this.observableProps.desativarTimeout : false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            valor: observable,
            modificadoExternamente: observable,
            timerSalvar: observable,
            setValor: action,
            clearTimeout: action,
            handleOnInput: action,
            onClickAway: action
        });

        this.setValor(this.observableProps.value);

        this.createReaction(
            reaction(
                () => this.observableProps.value,
                (valor) => {
                    this.modificadoExternamente = true;
                    this.valor = valor;
                }
            )
        );
        this.createReaction(
            reaction(
                () => this.valor,
                (conteudo) => {
                    if (this.modificadoExternamente) {
                        this.modificadoExternamente = false;
                        if (this.timerSalvar) {
                            this.clearTimeout();
                        }
                        return;
                    }

                    if (this.timerSalvar) {
                        this.clearTimeout();
                    }

                    if (!this.desativarTimeout) {
                        this.timerSalvar = setTimeout(() => {
                            this.salvar(conteudo);
                            this.clearTimeout();
                        }, this.tempoTimeout);
                    }
                }
            )
        );
    }

    setValor(value) {
        this.valor = value;
    }

    clearTimeout = () => {
        clearTimeout(this.timerSalvar);
        this.timerSalvar = undefined;
    };

    debouncedOnChange = SystemUtil.debounce((valor) => this.observableProps.onChange(valor), 500);

    handleOnChange = (valor) => {
        if (this.observableProps.onChange) {
            this.debouncedOnChange(valor);
        }
    };

    handleOnInput = (e) => {
        if (this.observableProps.usarBloqueio) {
            if (this.observableProps.bloqueio()) {
                this.modificadoExternamente = false;
                let valor = e.target.value;
                this.valor = valor;
                this.handleOnChange(valor);
                this.observableProps.callbackDesbloqueio();
            }
        } else {
            this.modificadoExternamente = false;
            let valor = e.target.value;
            this.valor = valor;
            this.handleOnChange(valor);
        }
    };

    onClickAway = (onLoseFocus) => {
        if (this.timerSalvar || (this.desativarTimeout && this.modificadoExternamente)) {
            this.clearTimeout();
            this.salvar(this.valor);
            this.modificadoExternamente = false;
        }

        onLoseFocus && onLoseFocus();
    };

    salvar = (valor) => {
        this.observableProps.salvar(valor);

        if (this.observableProps.callbackSalvar) {
            this.observableProps.callbackSalvar();
        }
    };

    render() {
        return (
            <TextField
                autoComplete="off"
                label={this.observableProps.label}
                placeholder={this.observableProps.label}
                size={this.observableProps.size ? this.observableProps.size : 'medium'}
                id={this.observableProps.id ? this.observableProps.id : undefined}
                multiline={this.observableProps.multiline !== undefined ? this.observableProps.multiline : true}
                disabled={this.observableProps.disabled}
                minRows={this.observableProps.minRows || 1}
                maxRows={this.observableProps.maxRows || 1}
                rows={this.observableProps.rows}
                fullWidth={true}
                value={this.valor}
                onBlur={this.onClickAway.bind(this, this.observableProps.onLoseFocus)}
                onInput={this.handleOnInput}
                inputRef={this.props.inputRef}
                style={this.observableProps.style ? this.observableProps.style : undefined}
                margin={this.observableProps.margin ? this.observableProps.margin : 'dense'}
                variant={this.observableProps.variant ? this.observableProps.variant : 'outlined'}
                onFocus={this.observableProps.onFocus}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                            borderColor: this.timerSalvar ? red[600] : 'default'
                        }
                    }
                }}
                spellCheck={this.observableProps.spellCheck ? this.observableProps.spellCheck : false}
                lang={'pt_BR'}
                slotProps={{
                    input: {
                        style: this.observableProps.InputPropsStyle
                            ? this.observableProps.InputPropsStyle
                            : { padding: '8px' }
                    },
                    htmlInput: this.observableProps.inputProps ? this.observableProps.inputProps : undefined,
                    inputLabel: { shrink: true }
                }}
            />
        );
    }
}

export default inject('stores')(observer(TextFieldSecretaria));
